import { enableBodyScroll, disableBodyScroll } from 'body-scroll-lock-upgrade';

export function filter(filterSelector = '.catalog__filter', openSelector = '.catalog__open-filter') {
  const filter = document.querySelector(filterSelector);
  if (!filter) return;

  const closeButton = filter.querySelector('.filter__close');
  const openButtons = document.querySelectorAll(openSelector);

  const open = () => {
    filter.classList.add('is-opened');
    disableBodyScroll(filter);
  };
  const close = () => {
    filter.classList.remove('is-opened');
    enableBodyScroll(filter);
  };
  const isOpen = () => filter.classList.contains('is-opened');
  const toggle = () => {
    if (!isOpen()) open();
    else close();
  };

  openButtons.forEach((btn) => btn.addEventListener('click', toggle));
  if (closeButton) closeButton.addEventListener('click', close);
}
